import { Domain } from '@app/shared/models/domain';
import { Provider } from '@app/shared/models/provider';
import { createAction, props } from '@ngrx/store';

// Get Main Provider
export const getMainProvider = createAction(
  '[Sso] Get Main Provider'
);

export const getMainProviderSuccess = createAction(
  '[Sso] Get Main Provider success',
  props<{ provider: Provider }>()
);

export const getMainProviderFailure = createAction(
  '[Sso] Get Main Provider failure',
  props<{ error: any }>()
);

// Create Provider
export const createProvider = createAction(
  '[Sso] Create Provider',
  props<{ provider: Provider }>()
);

export const createProviderSuccess = createAction(
  '[Sso] Create Provider success',
  props<{ provider: Provider }>()
);
export const createProviderFailure = createAction(
  '[Sso] Create Provider failure',
  props<{ error: any }>()
);

// Update Provider
export const updateProvider = createAction(
  '[Sso] Update Provider',
  props<{ oldIssuer: string, provider: Provider }>()
);

export const updateProviderSuccess = createAction(
  '[Sso] Update Provider success',
  props<{ provider: Provider }>()
);

export const updateProviderFailure = createAction(
  '[Sso] Update Provider failure',
  props<{ error: any }>()
);

// Load Domains
export const loadDomains = createAction(
  '[Sso] Load Domains'
);

export const loadDomainsSuccess = createAction(
  '[Sso] Load Domains Success',
  props<{ domains: Domain[] }>()
);

export const loadDomainsFailure = createAction(
  '[Sso] Load Domains Failure',
  props<{ error: any }>()
);
